// ==================== PRODUCTION CONFIGURATION ====================
// Centralized configuration for all backend API endpoints
// Update these URLs when deploying to production/staging environments

const config = {
  // Environment flag
  isBackend: true,
  voiceCallServerEnabled: process.env.REACT_APP_ENABLE_VOICE_CALL_SERVER !== 'false',

  // ==================== API BASE URLS ====================
  // OPS API - Port 8000 (drivers, vehicles, trips, notifications)
  opsApiUrl: process.env.REACT_APP_OPS_API_URL || 'http://localhost:8000/api/v1/ops',
  opsApiBase: process.env.REACT_APP_OPS_API_URL || 'http://localhost:8000/api/v1/ops',

  // Dispatch/Assignment API - Port 8001 (bookings, assignments, manual assignment, vehicle details)
  dispatchApiUrl: process.env.REACT_APP_DISPATCH_API_URL || 'http://localhost:8001/api',
  dispatchApiBase: process.env.REACT_APP_DISPATCH_API_URL || 'http://localhost:8001/api',

  // Legacy support (keep for backward compatibility)
  baseURLApi: process.env.REACT_APP_OPS_API_URL || 'http://localhost:8000/api/v1/ops',
  apiUrl: process.env.REACT_APP_OPS_API_URL || 'http://localhost:8000/api/v1/ops',

  // Customer API - Port 8003 (customers, conversations, users, bookings, location/vehicle resolution)
  customerApiUrl: process.env.REACT_APP_CUSTOMER_API_URL || '/api/customer',
  customerApiBase: process.env.REACT_APP_CUSTOMER_API_URL || '/api/customer',

  // Marketing API - Port 8010 (Segment Flow batches for Call Manager)
  marketingApiUrl: process.env.REACT_APP_MARKETING_API_URL || 'http://localhost:8010/api/marketing',
  marketingApiBase: process.env.REACT_APP_MARKETING_API_URL || 'http://localhost:8010/api/marketing',

  // Voice marketing tracker API (same summaries as Voice Tracker dashboard)
  voiceMktApiBase: process.env.REACT_APP_VOICE_MKT_API_URL || 'http://localhost:8010/api/voice-mkt',

  // B2B portal public origin — for resolving /uploads/ attachments from devbusiness
  dashB2bPublicUrl:
    process.env.REACT_APP_DASH_B2B_PUBLIC_URL ||
    (process.env.REACT_APP_DASH_B2B_URL || '').replace(/\/api\/b2b\/?$/, '') ||
    'https://devbusiness.unloadin.com',

  // Dash-Unload B2B API (ops New Customer → B2B onboard). Local: :8020; admin nginx may proxy /api/b2b.
  b2bApiBase:
    process.env.REACT_APP_B2B_API_URL ||
    process.env.REACT_APP_DASH_B2B_URL ||
    'http://localhost:8020/api/b2b',

  // Must match dash-unload backend OPS_ONBOARD_KEY
  opsOnboardKey: process.env.REACT_APP_OPS_ONBOARD_KEY || '',

  // Payment API - Port 8004 (payment links, status)
  paymentApiBase: process.env.REACT_APP_PAYMENT_API_URL || 'http://localhost:8004/api/payment',

  // ==================== WEBSOCKET URLS ====================
  // WebSocket URL for real-time escalation updates (Port 5005)
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:5005',
  escalationWebsocket: process.env.REACT_APP_WEBSOCKET_URL || 'ws://localhost:5005/ws/ops-escalation',

  // WS Server HTTP API - Port 5004 (remove-booking, clear-dismissed, etc.)
  wsServerApiBase: process.env.REACT_APP_WS_SERVER_API_URL || 'http://localhost:5004',

  // Voice Marketing Call Server - Port 3005 (outbound voice calls via LiveKit SIP)
  voiceCallServerBase: process.env.REACT_APP_VOICE_CALL_SERVER_URL || 'http://localhost:3005',

  // ==================== GOOGLE MAPS ====================
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyC_bY0WsXpMBZBeyoFfyJWIop3oI6P99Ok',

  // ==================== AUTH TOKEN ====================
  id_token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjpmYWxzZSwibG9naW4iOiJ1c2VyIiwiaWF0IjoxNTczNzQ4ODI1LCJleHAiOjE2MjA0MDQ4MjV9.Jd1Trqu6izHq2R3uw4enrDlQKG4mzZdipSMdYQD_9JM'
};

export default config;
